import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useUserSession } from '@vertesia/ui/session';
import { TypeRegistry } from './TypeRegistry.js';
const TypeRegistryContext = createContext({
    registry: undefined,
    isLoading: false,
    load: () => Promise.resolve(),
    reload: () => Promise.resolve(),
});
export function TypeRegistryProvider({ children }) {
    const { store, project } = useUserSession();
    const [registry, setRegistry] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const fetchRef = useRef(false);
    const load = useCallback(async () => {
        if (!project || fetchRef.current)
            return;
        fetchRef.current = true;
        setIsLoading(true);
        try {
            const types = await store.types.catalog.list({ layout: true });
            setRegistry(new TypeRegistry(types));
        }
        catch (err) {
            console.error('Failed to fetch types', err);
        }
        finally {
            setIsLoading(false);
            fetchRef.current = false;
        }
    }, [store, project]);
    const reload = useCallback(async () => {
        fetchRef.current = false;
        return load();
    }, [load]);
    // Reset when project changes
    useEffect(() => {
        setRegistry(undefined);
        fetchRef.current = false;
    }, [project]);
    return (_jsx(TypeRegistryContext.Provider, { value: { registry, isLoading, load, reload }, children: children }));
}
export function useTypeRegistry() {
    const ctx = useContext(TypeRegistryContext);
    useEffect(() => {
        if (!ctx.registry && !ctx.isLoading) {
            ctx.load();
        }
    }, [ctx.registry, ctx.isLoading]);
    return ctx;
}
//# sourceMappingURL=TypeRegistryProvider.js.map